import { useEffect, FC } from 'react';
import { datadogRum } from '@datadog/browser-rum';

export const SharedDatadogRumTimer: FC<{ timerName: string }> = ({ timerName }) => {
    useEffect(() => {
        if (datadogRum.getGlobalContext()) {
            datadogRum.addTiming(timerName);
        }
    }, [timerName]);
    return null;
};
